<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderOAuth',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'oauth',
    text: 'OAuth',
    to: AppRoute.OAuth,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
